import { SnLonLat } from '@lib/geo/helpers';

import { GoogleMapStyle } from '../enums';
import { MapBaseOverlay } from '../overlays';

export interface IGoogleMapEvents {
  click: SnLonLat;
  dblclick: SnLonLat;
  rightclick: SnLonLat;
  dragstart: undefined;
  drag: undefined;
  dragend: undefined;
  idle: undefined;
  tilesLoaded: undefined;
  tilesLoadError: { timeoutMs: number } | undefined;
  centerChange: undefined;
  boundsChange: undefined;
  zoomChange: number;
  styleChange: GoogleMapStyle;
  destroyed: void;

  'overlay:add': MapBaseOverlay;
  'overlay:remove': MapBaseOverlay;
}
